import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { TransferDetailView } from "modules/transfers";
import { useParams } from "react-router-dom";

const TransferDetailPage = () => {
  const { transferId } = useParams();

  return (
    <ContentLayout title={t("Transfer")}>
      <BoxShadowLayout>
        <TransferDetailView transferId={String(transferId)} />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default TransferDetailPage;
